import * as React from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';

import { AppRouting } from '../../AppConstants';
import { Loading } from '../Loading/Loading';

import styles from './Layout.module.scss';
import { Sidebar } from '../Sidebar/Sidebar';
import { PopoverDialog } from '../PopoverDialog/PopoverDialog';
import { observer } from 'mobx-react';
import { AppStore, AppStoreContext } from '../../Stores/AppStore';
import { useMemo } from 'react';
import {ConfirmationDialog} from "../ConfirmationDialog/ConfirmationDialog";
import {authService} from "../../index";

const GlobalTab = React.lazy(() => import('../Tabs/Global/GlobalTab'));
const ConditionTab = React.lazy(() => import('../Tabs/Condition/ConditionTab'));
const Effectiveness = React.lazy(() => import('../Tabs/Effective/EffectiveTab'));
const ServiceTab = React.lazy(() => import('../Tabs/Service/ServiceTab'));
const AdministrationTab = React.lazy(() => import('../Tabs/Administration/AdministrationTab'));

export const Layout = observer(() => {
    const appStore = useMemo(() => new AppStore(), []);
    const { isAdmin } = authService;

    return (
        <div className={styles.root}>
            <AppStoreContext.Provider value={appStore}>
                <Router>
                    <Sidebar/>
                    <div className={styles.main}>
                        <React.Suspense fallback={<Loading isSuspense/>}>
                            <Switch>
                                <Route path={AppRouting.Global} component={GlobalTab}/>
                                <Route path={AppRouting.Condition} component={ConditionTab}/>
                                <Route path={AppRouting.Effectiveness} component={Effectiveness}/>
                                <Route path={AppRouting.Service} component={ServiceTab}/>
                                { isAdmin && <Route path={AppRouting.Administration} component={AdministrationTab}/> }
                                <Redirect exact from="/" to={AppRouting.Condition}/>
                            </Switch>
                        </React.Suspense>
                        <PopoverDialog/>
                    </div>
                </Router>
                <ConfirmationDialog/>
            </AppStoreContext.Provider>
        </div>
    );
});

